<button class="btn btn-primary mx-2" (click)="cancleConfirmationPopup(confirmationPopup)">Cancel</button>

<ng-template #confirmationPopup>
  <app-modal title="Cancel Job" [modalRef]="modalRef" [positiveResponse]="modalButtonName" (onAction)="cancelModalResponse($event)">
    <p class="modal-body">Any changes done to the jobschedule would be lost. Do you want to continue?</p>
  </app-modal>
</ng-template>
